<template>
  <div class="overflow: auto">
    <v-row class="ma-2 d-flex align-center">
      <v-col sm="4">
        <v-btn @click="$emit('back')" outlined>{{ $t("back_short") }}</v-btn>
      </v-col>
      <v-col sm="4" style>
        <h3 style="text-align: center">{{ $t("item") }}</h3>
      </v-col>
      <v-col sm="4" />
    </v-row>

    <div class="mt-2" style="overflow: auto; max-height: 80vh;">
      <v-list>
        <div v-for="item in availableFlowerGenus" :key="item.id">
          <v-list-item @click="$emit('click', {key: 'genus', value: item})">
            <v-list-item-content>
              <div>
                <span class="filter-mob-font mr-2">{{ item.name }}</span>
              </div>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn icon>
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-divider />
        </div>
      </v-list>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      genus: null
    };
  },

  computed: {
    availableFlowerGenus() {
      return this.$store.state.searchQuery.available_flower_genus;
    }
  }
};
</script>

<style scoped>
</style>
